import InBetweenAds from '@/app/[lng]/(home)/search/(AdComponent)/InBetweenAds'
import { adInterval } from '@/app/[lng]/(home)/search/company-tab/components/CompanyList'
import NewsOutletCard from '@/app/[lng]/components/NewsOutlet/NewsOutletCard'
import NewsListingSkeleton from '@/app/[lng]/components/Skeletons/NewsListingSkeleton'
import CustomErrorBoundary from '@/app/[lng]/ErrorBoundary'
import { AdBannerScheduleType } from '@/app/types/adType'
import { NewsSearchResponse } from '@/app/types/newsSearchType'

interface CommonNewsListType {
  newsData: NewsSearchResponse
  isNewsDataLoading: boolean
  adsData: AdBannerScheduleType[]
}
const CommonNewsList = ({
  newsData,
  isNewsDataLoading,
  adsData,
}: CommonNewsListType) => {
  if (isNewsDataLoading) {
    return (
      <div className="pt-[12.5px] border-t border-gray_btn border-solid mobile-width w-full">
        <div className="gap-2 flex flex-col min-w-[600px]">
          <NewsListingSkeleton />
        </div>
      </div>
    )
  }
  return (
    <div className="pt-[12.5px] border-t border-gray_btn border-solid min-w-[600px] ">
      <div className="gap-2 flex flex-col">
        {newsData?.news?.map((newsItem, index) => (
          <CustomErrorBoundary key={newsItem.title}>
            <div
              key={`${newsItem.id}+newsList`}
              className="flex flex-col gap-4 "
            >
              <NewsOutletCard newsData={newsItem} />
              {(index + 1) % adInterval === 0 && (
                <InBetweenAds
                  index={index}
                  adsData={
                    adsData[Math.floor(index / adInterval) % adsData.length]
                  }
                />
              )}
            </div>
          </CustomErrorBoundary>
        ))}
      </div>
    </div>
  )
}

export default CommonNewsList
